import { DataSource, Label, Layout, Map, Splitter, Table } from "@mcleod/components";

export abstract class AutogenLayoutZoneRegionList extends Layout {
    labelSearchZoneRegion: Label;
    mapRoute: Map;
    sourceZoneRegion: DataSource;
    splitterZoneRegion: Splitter;
    tableZoneRegionList: Table;
}
